export default {"src":"/_next/static/media/MDLZ.7fd4d4b4.svg","height":18,"width":18};